import script from "./index.vue?vue&type=script&setup=true&lang=jsx"
export * from "./index.vue?vue&type=script&setup=true&lang=jsx"

import "./index.vue?vue&type=style&index=0&id=6d6bcbdb&lang=less"
import "./index.vue?vue&type=style&index=1&id=6d6bcbdb&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d6bcbdb"]])

export default __exports__